// Drawn on Figma, converted to react component using https://react-svgr.com/playground/

const ThemeIcon = () => (
	<svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#a)">
			<circle cx={8} cy={8} r={7.5} stroke="currentColor" strokeWidth={1.5} />
			<path
				d="M13.643 2.331A8 8 0 0 1 2.33 13.645L13.643 2.331Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h16v16H0z" />
			</clipPath>
		</defs>
	</svg>
);

export default ThemeIcon;
